module.exports = "//__CDN_HOST__/2.0.8/img/auto-loan-calculator-banner.49038452.png";